<template>
    <vs-popup classContent="popup-example" :title="article.title" :active.sync="showPopup">
        <!-- <div class="img-container">
            <img :src="srcFile(article.thumbnail)" :alt="article.title" class="rounded card-img" />
        </div>
        <div class="card-text">
            <h5 class="mt-3">{{ article.title }}</h5>
            <p><span v-html="article.text"></span></p>
        </div> -->
        <div class="item-content">
            <div class="product-details p-6">
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/5 w-full flex items-center justify-center">
                        <img v-if="article.thumbnail" :src="srcFile(article.thumbnail)" :alt="article.title" class="responsive">
                        <img v-else src="./../../../../assets/images/logo/logo.png" :alt="article.title" class="responsive grid-view-img px-4">
                    </div>
                    <div class="vx-col md:w-4/5 w-full">
                        <h3>{{ article.title }}</h3>
                        <vs-divider />

                        <p style="overflow-wrap: break-word;"><span v-html="article.text"></span></p>
                    </div>
                </div>
            </div>
        </div>
    </vs-popup>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
    name: 'ContentArticle',

    props: {
        popupContentArticle: {
            type: Boolean,
            default: false,
        },
        articleId: Number
    },
    
    components: {
    },
    
    data() {
		return{
            showPopup: false,
            article: {},
		}
    },

    watch: { 
      	popupContentArticle(newVal) {
            this.showPopup = newVal
            if(newVal == true){
                this.$vs.loading()
                this.$store.dispatch('getPostInfo', this.articleId)
                .then(res => {
                    this.article = res.data[0]
                    this.$vs.loading.close()
                }).catch(() => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: '',
                        text: 'خطا در اتصال به اینترنت',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                })
            }
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupContentArticle', newVal)
        },
    },

    methods: {
        srcFile(src) {
            return 'https://appapi.akambc.com/' + src
        },
    }
}
</script>

<style scope>
.con-vs-popup .vs-popup {
    width: 90% !important;
}

.card-text {
    display: inline;
}




/* .color-radio {
    height: 2.28rem;
    width: 2.28rem;
}

.color-radio > div {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.item-features {
    background-color: #f7f7f7;
}

.item-features .theme-dark {
}

.product-sales-meta-list .vs-list--icon{
    padding-left: 0;
}

.related-product-swiper .swiper-wrapper{
    padding-bottom: 2rem;
}

.related-product-swiper .swiper-wrapper > .swiper-slide {
    background-color: #f7f7f7;
    box-shadow: 0 4px 18px 0 rgba(0,0,0,0.1), 0 5px 12px 0 rgba(0,0,0,0.08) !important;
}

.related-product-swiper .swiper-wrapper > .swiper-slide.theme-dark {
}

.swiper-button-next,
.swiper-button-prev {
    transform: scale(.5);
    filter: hue-rotate(40deg);
}

.swiper-button-next {
    right: 0
}

.swiper-button-prev {
    left: 0;
} */
</style>